import { cn } from '@/lib/utils'

interface OccupancyBarProps {
  pct: number
}

export function OccupancyBar({ pct }: OccupancyBarProps) {
  const colorClass =
    pct < 60
      ? 'bg-green-500'
      : pct < 80
        ? 'bg-amber-500'
        : 'bg-red-500'

  return (
    <div className="flex items-center gap-2">
      <div className="h-2 flex-1 min-w-[60px] rounded-full bg-muted overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-all', colorClass)}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-[10px] font-mono text-muted-foreground w-8 text-right">
        {pct}%
      </span>
    </div>
  )
}
